import React from 'react'
import {Flex} from '/app/src/component'
import style from './style.css'

export default class P1 extends React.Component {
    render(){
        return (
            <Flex {...this.props} className={style.Label}  width='100%' vAlignContent='center'>
                {this.props.children}
            </Flex>
        )
    }

}



// WEBPACK FOOTER //
// ./src/component/Html/P1/index.js